import React, { useState } from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const nav = [
  { to: '/admin', label: 'Dashboard', icon: '📊', end: true },
  { to: '/admin/students', label: 'Students', icon: '👥' },
  { to: '/admin/questions', label: 'Questions', icon: '❓' },
  { to: '/admin/videos', label: 'Videos', icon: '🎬' },
  { to: '/admin/cards', label: 'Flashcards', icon: '🃏' },
  { to: '/admin/manual-reviews', label: 'Manual Reviews', icon: '🚩' },
  { to: '/admin/question-lookup', label: 'Question Lookup', icon: '🔎' },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const handleLogout = () => { logout(); navigate('/login'); };

  return (
    <div style={{ display: 'flex', minHeight: '100vh' }}>
      {/* Sidebar */}
      <aside style={{
        width: 240, background: 'var(--sidebar-bg)', color: 'var(--sidebar-text)',
        display: 'flex', flexDirection: 'column', flexShrink: 0,
        position: 'fixed', top: 0, left: 0, height: '100vh', zIndex: 100,
        transform: open ? 'translateX(0)' : undefined,
      }} className="sidebar">
        <div style={{ padding: '24px 20px 16px', borderBottom: '1px solid rgba(255,255,255,0.08)' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <span style={{ fontSize: 24 }}>🎯</span>
            <div>
              <div style={{ color: 'white', fontFamily: 'Sora', fontWeight: 700, fontSize: 15 }}>Dream NEET</div>
              <div style={{ fontSize: 11, opacity: 0.5 }}>Admin Panel</div>
            </div>
          </div>
        </div>
        <nav style={{ flex: 1, padding: '12px 10px' }}>
          {nav.map(n => (
            <NavLink key={n.to} to={n.to} end={n.end} style={({ isActive }) => ({
              display: 'flex', alignItems: 'center', gap: 10, padding: '10px 12px',
              borderRadius: 8, marginBottom: 2, textDecoration: 'none', fontSize: 14,
              color: isActive ? 'white' : 'var(--sidebar-text)',
              background: isActive ? 'var(--sidebar-active)' : 'transparent',
              fontWeight: isActive ? 600 : 400,
            })}>
              <span>{n.icon}</span>{n.label}
            </NavLink>
          ))}
        </nav>
        <div style={{ padding: '16px 20px', borderTop: '1px solid rgba(255,255,255,0.08)' }}>
          <div style={{ fontSize: 12, opacity: 0.5, marginBottom: 8 }}>Signed in as</div>
          <div style={{ color: 'white', fontWeight: 600, fontSize: 14, marginBottom: 12 }}>{user?.full_name || 'Admin'}</div>
          <button onClick={handleLogout} className="btn btn-ghost"
            style={{ width: '100%', justifyContent: 'center', color: 'var(--sidebar-text)', borderColor: 'rgba(255,255,255,0.15)' }}>
            Sign Out
          </button>
        </div>
      </aside>
      {/* Main */}
      <main style={{ marginLeft: 240, flex: 1, padding: '32px', minHeight: '100vh' }}>
        <Outlet />
      </main>
      <style>{`
        @media (max-width: 768px) {
          aside.sidebar { transform: translateX(-100%); }
          main { margin-left: 0 !important; padding: 16px !important; }
        }
      `}</style>
    </div>
  );
}
